import { useState } from 'react';
import Question from './Question';

const QuizApp = () => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const questions = [
    {
      question: 'How familiar are you with Kingsley Stickers & Plastics?',
      options: ['Very familiar', 'Somewhat familiar', 'Heard the name only', 'Not at all familiar'],
      description: 'This question helps us understand your awareness of our brand.',
    },
    {
      question: 'Where did you first hear about Kingsley Stickers & Plastics?',
      options: ['Word of mouth', 'WhatsApp or messages', 'JustDial or Google search', 'Visited the shop directly', 'Social media (Instagram/Facebook)'],
      description: 'Knowing your source helps us refine our marketing strategy.',
    },
    {
      question: 'How often do you purchase sticker or branding-related materials?',
      options: ['Weekly', 'Biweekly', 'Monthly', 'Rarely', 'Never'],
      description: 'This helps us gauge your purchasing frequency.',
    },
    {
      question: 'Have you ever purchased from Kingsley Stickers & Plastics?',
      options: ['Yes', 'No'],
      description: 'Your purchase history informs our customer engagement plans.',
    },
    {
      question: 'If yes, how satisfied are you with their product quality?',
      options: ['Very satisfied', 'Satisfied', 'Neutral', 'Dissatisfied', 'Very dissatisfied'],
      description: 'Feedback on quality guides our product improvements.',
      conditional: true,
    },
    {
      question: 'Would you recommend Kingsley to others in your business network?',
      options: ['Definitely', 'Maybe', 'Not sure', 'No'],
      description: 'Your recommendation reflects our brand reputation.',
    },
    {
      question: 'Which platform do you commonly use to find local suppliers?',
      options: ['Google', 'WhatsApp', 'JustDial', 'Instagram', 'Referral/Word of Mouth'],
      description: 'This helps us focus our digital presence.',
    },
    {
      question: 'What type of digital content grabs your attention the most?',
      options: ['Product images with price', 'Product videos', 'Customer reviews/testimonials', 'Discounts and offers', 'Catalogs via WhatsApp'],
      description: 'Understanding preferences improves our content strategy.',
    },
    {
      question: 'Do you follow any signage or branding material suppliers on social media?',
      options: ['Yes', 'No'],
      description: 'This indicates your engagement with suppliers online.',
    },
    {
      question: 'How likely are you to buy from a supplier that posts regularly on digital platforms?',
      options: ['Very likely', 'Likely', 'Neutral', 'Unlikely', 'Very unlikely'],
      description: 'Regular posting impact on purchasing decisions.',
    },
    {
      question: 'What is your preferred mode of communication with a supplier?',
      options: ['Phone call', 'WhatsApp', 'Email', 'Social Media DM', 'Visiting in person'],
      description: 'This helps us optimize communication channels.',
    },
    {
      question: 'What factors influence your buying decision the most?',
      options: ['Price', 'Product range', 'Customer service', 'Delivery time', 'Brand reputation'],
      description: 'Key factors shape our business priorities.',
    },
    {
      question: 'Do you think Kingsley should have a Google Business profile with photos, timings, and maps?',
      options: ['Yes', 'No', 'Not sure'],
      description: 'This guides our online visibility strategy.',
    },
    {
      question: 'Would you be interested in receiving product updates or catalogs via WhatsApp?',
      options: ['Yes', 'No', 'Maybe'],
      description: 'This helps us plan our outreach methods.',
    },
    {
      question: 'On a scale of 1 to 5, how memorable is the brand name “Kingsley Stickers & Plastics”? (1 = Not at all memorable, 5 = Highly memorable)',
      options: ['1', '2', '3', '4', '5'],
      description: 'Your rating helps us assess brand recall.',
    },
  ];

  const handleAnswerSelect = (option) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [currentQuestion]: option,
    }));
  };

  const handleNext = () => {
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      setIsSubmitted(true);
    }
  };

  const handlePrevious = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
    }
  };

  const progress = ((currentQuestion + 1) / questions.length) * 100;

  // Check if the current question is conditional and should be skipped
  const shouldShowQuestion = !questions[currentQuestion].conditional || 
    (questions[currentQuestion].conditional && questions[currentQuestion - 1]?.options.indexOf(selectedAnswers[currentQuestion - 1]) === 0); // 'Yes' for question 4

  return (
    <div className="max-w-xl p-8 bg-white rounded-2xl shadow-lg">
      {isSubmitted ? (
        <div className="text-center">
          <div className="flex justify-center mb-4">
            <div className="relative w-16 h-16">
              <div className="absolute w-16 h-16 bg-green-selected rounded-full flex items-center justify-center">
                <span className="text-white text-3xl font-bold animate-rotate-twice">✓</span>
              </div>
            </div>
          </div>
          <h2 className="text-2xl font-bold text-dark-purple">Thank You for Submitting!</h2>
          {/* <p className="text-lg text-gray-600 mt-4">We appreciate your feedback.</p> */}
        </div>
      ) : shouldShowQuestion ? (
        <Question
          question={questions[currentQuestion]}
          currentQuestion={currentQuestion}
          totalQuestions={questions.length}
          selectedAnswer={selectedAnswers[currentQuestion]}
          onAnswerSelect={handleAnswerSelect}
          onNext={handleNext}
          onPrevious={handlePrevious}
          progress={progress}
          isLastQuestion={currentQuestion === questions.length - 1}
        />
      ) : (
        handleNext()
      )}
    </div>
  );
};

export default QuizApp;